import React from 'react';
import { NavLink } from 'react-router-dom';
import LeftSliderPtc from '../../AdsSlider/LeftSlider_300x250_1';
import LeftSliderFaucet from '../../AdsSlider/LeftSlider_300x250_2';
//import GoogleAd from '../../GoogleAds';

import './styles.css';

const AsideLeft = () => {
    
    return (
        <>
            <div className="asides column col-md-2 p-0 mb-1 tfx-1" id="sidebar">
                            <div className="aside aside-left pt-4"  id="main">
                                <h1 className="display-4">Welcome, <small>Guest</small></h1>

                                <hr className="mt-4"/>

                                <ul className="ml-3 mr-3 ">
                                    <li  activeClassName="active tfx-1">
                                        <NavLink className="links tfx-1" to="/ptc-sites">
                                            PTC Sites
                                        </NavLink>
                                    </li> 
                                    <li activeClassName="active tfx-1">
                                        <NavLink className="tfx-1" to="/faucet-sites">
                                            Faucet Sites
                                        </NavLink>
                                    </li>
                                    <li activeClassName="active tfx-1">
                                        <NavLink className="tfx-1" to="/cloudmining-sites">
                                            Cloud Mining
                                        </NavLink>
                                    </li>
                                    <li activeClassName="active tfx-1">
                                        <NavLink className="tfx-1" to="/trading-sites">
                                           Trading Sites
                                        </NavLink>
                                    </li>
                                    <li className="links tfx-1">
                                        <NavLink className="tfx-1" to="/mobile-apps">
                                            Mobile Apps
                                        </NavLink>
                                    </li>
                                    <li activeClassName="active tfx-1">
                                        <NavLink className="tfx-1" to="/others">
                                            Others
                                        </NavLink>
                                    </li>
                                </ul>

                                <div className="aside-ads-left mt-4 m-2 pt-2">
                                    <a href="#" target="_blank" className="campaign-link">
                                        <div className="campaign pb-2">
                                            <div className="campaign-img">
                                                
                                            </div>
                                        </div>
                                        <div className="campaign pb-2">
                                            <div className="campaign-img">
                                                <LeftSliderFaucet />
                                            </div>
                                        </div>
                                        <div className="campaign mt-3 pb-2">
                                            <div className="campaign-img">
                                                <LeftSliderPtc />
                                            </div>
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </div>
        </>
    )
};

export default AsideLeft;
